export default __webpack_public_path__ + "static/MS-Sans-Serif-93905f8d36305f50ab93ae32178d7cc3.ttf";